// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__H7BqL","slider":"Switch_slider__xtJal"};